import axios from "axios";

export const GET_LAST_BY_CASE = "mc_movements/getLastByCase";
export const STORE_BY_CASE = "mc_movements/storeMcMovementByCase";
export const UPDATE_BY_CASE = "mc_movements/updateMcMovementByCase";


export const getLasMcMovementtByCase = function (caseId) {
  return axios.get(`${GET_LAST_BY_CASE}/${caseId}`);
}

export const storeMcMovementByCase = (caseSlug, data) => {
  return axios.post(`${STORE_BY_CASE}/${caseSlug}`, data);
}

/**
 * Deja en tra_mc_movements constancia de un cambio de estacion con la asignacion vigente del caso
 * (categoria, celula, concierge, medico, enfermera), para los envios que no pasan por el
 * formulario de asignacion. `motive` dice de donde a donde se envio el caso.
 */
export const storeCaseMovement = (caseRecord, motive) =>
  storeMcMovementByCase(caseRecord.slug, {
    axaCategories: caseRecord.axaCategories,
    cellId: caseRecord.cellId,
    concergeId: caseRecord.concergeId,
    doctorFollowId: caseRecord.doctorFollowId,
    nurseFollowId: caseRecord.nurseFollowId,
    reasonMC: caseRecord.reasonMC,
    reassignmentMotive: motive,
  });
